import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AsyncPipe, NgSwitch, NgSwitchCase } from '@angular/common';
import {
  FreshProductInfoPageComponent
} from '../../layout/fresh/fresh-product-info-page/fresh-product-info-page.component';
import { ConfigRepository } from '../../shared/repositories/config.repository';
import { Observable } from 'rxjs';
import { Layout } from '../../api/v1/models/layout';


@UntilDestroy()
@Component({
  selector: 'app-product-info',
  templateUrl: './product-info.component.html',
  styleUrls: ['./product-info.component.scss'],
  standalone: true,
  imports: [
    NgSwitch,
    NgSwitchCase,
    AsyncPipe,
    FreshProductInfoPageComponent,
  ]
})
export default class ProductInfoComponent {
  constructor(
    private config: ConfigRepository,
  ) {}
  layout$: Observable<Layout> = this.config.layout$;
  layouts = Layout;
}
